
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-2f4ec5a4&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./VAColorPaletteSet.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./VAColorPaletteSet.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-2f4ec5a4!../../node_modules/vue-loader/lib/selector?type=template&index=0!./VAColorPaletteSet.vue"),
  /* scopeId */
  "data-v-2f4ec5a4",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/VAColorPaletteSet.vue
// module id = 447
// module chunks = 1